Vue.component("MainMenu", {
    props: ["atHomePage", "menuElements", "settings", "isFullscreen"],
    template: `
        <transition name="menuanimation">
            <nav id="menu" v-if="settings.enabled">
                <div class="menu__topbar">
                    <h1 v-html="title"></h1>

                    <div class="menu__topbar__breadcrumbs">
                        <button class="menu__topbar__breadcrumbs__backbutton" @click="back">
                            <img src="assets/img/ui/back-breadcrumbs.svg">
                        </button>
                        <span v-for="crumb in breadcrumbs" @click="gotoRoute(crumb.route)">{{crumb.title}}</span>
                    </div>
                </div>

                <div class="menu__sidebar">
                    <button class="menu__sidebar__showprogram" 
                        :class="{'menu__sidebar__showprogram--open': programShown}"
                        @click="toggleProgram"
                        v-html="programButtonText"
                        v-if="programEnabled">
                        DAGENS PROGRAM
                    </button>

                    <div class="menu__sidebar__program__wrapper" v-if="programEnabled">
                        <transition enter-active-class="fadeInLeft" leave-active-class="fadeOutLeft">
                            <aside class="menu__sidebar__program" v-if="programShown">

                                <ul>
                                    <li v-for="(event, i) in program" :key="event.title" :class="{'event--active': getCurrentEvent(event.timestamp, i)}">
                                        <span v-html="event.hideTimestamp === false ? formatDate(event.timestamp) : ''"></span>

                                        <div>
                                            <h4 v-html="event.title"></h4>
                                            <h5 v-html="event.subtitle"></h5>
                                            <button @click="gotoRoute(event.link)" v-if="hasLink(event)">Deltag</button>
                                            <button @click="gotoSceneRoute(event.sceneRoute)" v-if="hasSceneRoute(event)">Deltag</button>
                                        </div>
                                    </li>
                                </ul>

                                
                                <button class="menu__sidebar__program__close" @click="toggleProgram">
                                    <img src="assets/img/ui/close-white.svg">
                                </button>
                            </aside>
                        </transition>
                    </div>

                    <button class="menu__sidebar__fullscreen" @click="fullscreen">
                        <img src="assets/img/ui/fullscreen.svg" alt="fullscreen icon">
                    </button>
                </div>
            </nav>
        </transition>
    `,
    data() {
        return {
            // variables for this instance of the main menu
            programShown: false,
            title: "",

            program: [],
            programEnabled: true,
            programButtonText: ""
        }
    },
    created() {},
    mounted() {
        this.getProgramData();
    },
    methods: {
        home() {
            // call home function from pageScene
            this.$emit("home")
        },
        back() {
            // call back function from pageScene
            this.$emit("back");
        },
        fullscreen() {
            // call fullscreen function from pageScene
            app.radio.$emit("app-fullscreen-toggle")
        },
        toggleProgram() {
            // hide / unhide menu
            this.programShown = !this.programShown;
        },
        openLink(url) {
            // handler for external links, opens in new tab.
            window.open(url, "_blank");
        },
        gotoRoute(route) {
            if (this.$route.path !== route) {
                this.$router.push(route)
            }
        },
        gotoSceneRoute(sceneRoute) {
            console.log('GOTOSCENE', sceneRoute);

            var route = false;
            var sceneInfo = touchKit.PageManager.sceneInfo(sceneRoute);

            if (sceneInfo.route) {
                route = '/' + sceneInfo.route;
            }

            if (route && this.$route.path !== route) {
                this.$router.push(route);
            }
        },
        
        formatDate(date) {
            let hour = (new Date(date)).getHours();
            let minute = (new Date(date)).getMinutes();

            return ("0" + hour).slice(-2) + ":" + ("0" + minute).slice(-2)
        },

        getCurrentEvent(date, index) {
            let eventDate = new Date(date)
            let currentDate = new Date();
            let nextEvent = this.program[index + 1] ? new Date(this.program[index + 1].timestamp) : false;

            //console.log(nextEvent)

            //check if even date and year
            if (!(currentDate.getDate() === eventDate.getDate() && currentDate.getFullYear() === eventDate.getFullYear())) {
                return false
            } else {
                // check if event is started
                if (Date.parse(currentDate) > Date.parse(eventDate)) {

                    //check if next event is started
                    if (Date.parse(currentDate) > Date.parse(nextEvent)) {
                        return false;
                    } else {
                        return true;
                    }

                } else {
                    return false;
                }
            }
        },
        getProgramData() {
            for(var x = 0; app.data.custom.length > x; x++) {
                if(app.data.custom[x].type == "program") {
                    this.program = app.data.custom[x].data.programEvents;
                    this.title = app.data.custom[x].data.title;
                    this.programButtonText = app.data.custom[x].data.buttonText;
                    this.programEnabled = app.data.custom[x].data.enabled;
                    break;
                } 
            }
            
            for (var i = 0; this.program.length > i; i++) {
                this.program[i].timestamp = new Date(this.program[i].timestamp);
            }
        },
        hasLink(li) {
            return li.link !== "" && li.hasOwnProperty("link")
        },
        hasSceneRoute(li) {
            return li.sceneRoute !== null
        }
    },
    computed: {
        breadcrumbs() {
            const result = [];
            this.$route.path.split("/").splice(2).reduce((a, c) => {
                var temp = a + c + "/";
                result.push(temp);
                return temp;
            }, "/scene/");

            return result.map(o => {
                return {
                    route: o.replace(/:\d+/, "").replace(/\/$/, ""),
                    title: touchKit.PageManager.pageTitle(o) === false ? touchKit.PageManager.pageTitle(app.settings.get("defaultRoute").value.split('/scene/')[1]) : touchKit.PageManager.pageTitle(o)
                }
            }).filter(o => (o.title !== "" && o.title !== undefined))
        }
    },
})